<template>
  <div id="app">
    <navbar />
    <home />
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Home from "./pages/Home.vue";

export default {
  name: "App",
  components: {
    Navbar,
    Home
  }
};
</script>

<style>
* {
  box-sizing: border-box;
  font-family: "Raleway", Avenir, Helvetica, Arial, sans-serif;
  transition: all 0.25s ease;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0px;
  padding: 0px;
}

#app {
  font-family: "Raleway", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #eee;
}
</style>
